


// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Card,
//   CardMedia,
//   CardContent,
//   Typography,
//   Button,
//   useMediaQuery,
//   Pagination
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { addProperty } from '../../../Commonlibs/userSlice';
// import Loader from '../../../Loader/Loader'; // Import your custom Loader component

// // Import Material UI icons for amenities
// import BedIcon from '@mui/icons-material/Bed';
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import SquareFootIcon from '@mui/icons-material/SquareFoot';

// const FeaturedView = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const isLoggedIn = useSelector(state => state.user.isAuthenticated);
//   const userData = useSelector(state => state.user.user);

//   // Pagination states
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalProperties, setTotalProperties] = useState(0);

//   useEffect(() => {
//     const fetchCommercialProperties = async () => {
//       try {
//         setLoading(true);

//         // ✅ NEW API CALL with pagination - GET request
//         const response = await fetch(
//           `https://propertydealstalk.com/api/property/getPropertiesByType?property_type=commercial&page=${page}&limit=10`,
//           {
//             method: 'GET',
//             headers: {
//               'Content-Type': 'application/json',
//             }
//           }
//         );

//         if (!response.ok) {
//           throw new Error('Failed to fetch commercial properties');
//         }

//         const data = await response.json();

//         if (data.success && data.properties) {
//           setProperties(data.properties);

//           // Set pagination data from API response
//           if (data.pagination) {
//             setTotalPages(data.pagination.totalPages);
//             setTotalProperties(data.pagination.total);
//           }

//           // Store each property ID in Redux
//           data.properties.forEach(property => {
//             dispatch(addProperty(property.id));
//           });
//         } else {
//           throw new Error(data.message || 'Failed to get property data');
//         }
//       } catch (err) {
//         console.error('Error fetching commercial properties:', err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCommercialProperties();
//   }, [dispatch, page]);

//   const recordPropertyView = async (propertyId) => {
//     if (!isLoggedIn || !userData) {
//       console.log('User not logged in, skipping view recording');
//       return;
//     }

//     try {
//       const userId = userData.id;

//       if (!userId) {
//         console.error('User ID not found in user data');
//         return;
//       }

//       console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

//       const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId
//         }),
//       });

//       const data = await response.json();

//       if (data.statusCode === 200) {
//         console.log('Property view recorded successfully:', data.result);
//       } else {
//         console.error('Failed to record property view:', data.message);
//       }
//     } catch (err) {
//       console.error('Error recording property view:', err);
//     }
//   };

//   const handlePageChange = (event, value) => {
//     setPage(value);
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   // ✅ Function to format price with Indian numbering system (lakhs format)
//   const formatPrice = (price) => {
//     if (!price || price === 0 || price === '0') return '';
    
//     const priceStr = price.toString();
//     const lastThree = priceStr.substring(priceStr.length - 3);
//     const otherNumbers = priceStr.substring(0, priceStr.length - 3);
    
//     if (otherNumbers !== '') {
//       return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
//     }
    
//     return lastThree;
//   };

//   // ✅ Function to check if image has valid data
//   const hasValidImage = (base64) => {
//     return base64 && base64.length > 100 && base64 !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEEoSeleaKApYsGNby651rbv2Xda1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=";
//   };

//   // ✅ Function to check if a value is valid (not null, undefined, 'N/A', or empty)
//   const isValidValue = (value) => {
//     return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
//   };

//   // ✅ NEW: Function to format time ago (like "2w ago")
//   const getTimeAgo = (dateString) => {
//     if (!dateString) return '';
    
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffInSeconds = Math.floor((now - date) / 1000);
    
//     const intervals = {
//       y: 31536000,
//       mo: 2592000,
//       w: 604800,
//       d: 86400,
//       h: 3600,
//       m: 60,
//       s: 1
//     };
    
//     for (const [key, value] of Object.entries(intervals)) {
//       const interval = Math.floor(diffInSeconds / value);
//       if (interval >= 1) {
//         return `${interval}${key} ago`;
//       }
//     }
    
//     return 'just now';
//   };

//   // ✅ FIXED: Function to get display price - matches TalkView.jsx logic
//   const getDisplayPrice = (property) => {
//     // Check if this is a rental property (case-insensitive comparison)
//     const category = property.category || property.commercial_catgory || '';
//     const isRental = category.toLowerCase() === 'rent';

//     if (isRental) {
//       // For rental properties, prioritize monthly_rent
//       if (isValidValue(property.monthly_rent) && property.monthly_rent !== 0) {
//         return property.monthly_rent;
//       }
//     }

//     // For sale properties or if monthly_rent is not available, use asking_price
//     if (isValidValue(property.asking_price) && property.asking_price !== 0) {
//       return property.asking_price;
//     }

//     return null; // Return null if no price is available
//   };

//   // ✅ Get only valid property amenities
//   const getPropertyAmenities = (property) => {
//     const amenities = [];

//     // Check BHK
//     if (isValidValue(property.bhk)) {
//       amenities.push({
//         type: 'BHK',
//         value: `${property.bhk} BHK`,
//         icon: <BedIcon />
//       });
//     }

//     // Check Floor - only add if both select_floor and total_floors are valid
//     if (isValidValue(property.select_floor) && isValidValue(property.total_floors)) {
//       amenities.push({
//         type: 'Floor',
//         value: `${property.select_floor}/${property.total_floors} Floor`,
//         icon: <ApartmentIcon />
//       });
//     }

//     // Check Size
//     if (isValidValue(property.property_size)) {
//       const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
//       amenities.push({
//         type: 'Size',
//         value: `${property.property_size} ${sizeUnit}`,
//         icon: <SquareFootIcon />
//       });
//     }

//     return amenities;
//   };

//   const handleViewProperty = (propertyId) => {
//     recordPropertyView(propertyId);
//     dispatch(addProperty(propertyId));
//   };

//   return (
//     <Box
//       sx={{
//         backgroundColor: '#fff',
//         padding: '0 20px 40px',
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '30px',
//         marginTop: '30px',
//         fontFamily: 'Outfit',
//       }}
//     >
//       {/* ✅ Custom Loading Effect */}
//       {loading && <Loader />}

//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           margin: '20px 0',
//           position: 'relative',
//         }}
//       >
//         <Box sx={{ width: '100%', textAlign: 'center' }}>
//           <Typography
//             sx={{
//               fontSize: '1.5rem',
//               fontWeight: 600,
//               position: 'absolute',
//               left: '50%',
//               transform: 'translateX(-50%)',
//               width: 'auto',
//             }}
//           >
//             Commercial Properties
//           </Typography>
//         </Box>
//         <Button
//           component={Link}
//           to="/"
//           variant="text"
//           sx={{
//             color: '#626262',
//             fontSize: '0.8rem',
//             fontWeight: 500,
//             zIndex: 1,
//             marginLeft: 'auto',
//           }}
//         >
//           Back to Home
//         </Button>
//       </Box>

//       {error ? (
//         <Typography color="error" sx={{ textAlign: 'center' }}>
//           {error}
//         </Typography>
//       ) : properties.length === 0 && !loading ? (
//         <Typography sx={{ textAlign: 'center' }}>
//           No commercial properties found
//         </Typography>
//       ) : !loading ? (
//         <>
//           <Box
//             sx={{
//               display: 'grid',
//               gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(300px, 1fr))',
//               gap: '20px',
//               alignItems: 'stretch',
//             }}
//           >
//             {properties.map((property) => {
//               const isResidential = property.property_type === 'residential';
//               const isReadyToMove = property.construction_status === 'ready to move';
//               const hasImage = hasValidImage(property.image);
//               const propertyAmenities = getPropertyAmenities(property);
//               const displayPrice = getDisplayPrice(property);
//               const isRental = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';
//               const timeAgo = getTimeAgo(property.updatedAt || property.createdAt);

//               return (
//                 <Box
//                   key={property.id}
//                   sx={{
//                     width: '100%',
//                     display: 'flex',
//                     justifyContent: 'center',
//                   }}
//                 >
//                   <Card
//                     sx={{
//                       width: { xs: '100%', sm: 360, md: '100%' },
//                       maxWidth: 350,
//                       height: '100%',
//                       backgroundColor: '#fff',
//                       borderRadius: '12px',
//                       boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
//                       overflow: 'hidden',
//                       transition: 'transform 0.3s ease',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       '&:hover': {
//                         transform: 'translateY(-5px)',
//                       },
//                     }}
//                   >
//                     <Box sx={{ position: 'relative', width: '100%', height: 200, overflow: 'hidden' }}>
//                       {hasImage ? (
//                         <CardMedia
//                           component="img"
//                           image={`data:image/png;base64,${property.image}`}
//                           alt={property.property_name}
//                           sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
//                         />
//                       ) : (
//                         <Box
//                           sx={{
//                             width: '100%',
//                             height: '100%',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             backgroundColor: '#f5f5f5',
//                             border: '1px dashed #ccc'
//                           }}
//                         >
//                           <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                             No images uploaded
//                           </Typography>
//                         </Box>
//                       )}

//                       {/* ✅ Time Ago Badge - Positioned at top-right */}
//                       {timeAgo && (
//                         <Box
//                           sx={{
//                             position: 'absolute',
//                             top: '8px',
//                             right: '8px',
//                             bgcolor: 'rgba(0, 0, 0, 0.7)',
//                             color: '#fff',
//                             px: '8px',
//                             py: '4px',
//                             borderRadius: '4px',
//                             fontSize: '11px',
//                             fontWeight: 500,
//                             zIndex: 3,
//                           }}
//                         >
//                           {timeAgo}
//                         </Box>
//                       )}

//                       <Box
//                         sx={{
//                           position: 'absolute',
//                           bottom: 0,
//                           left: 0,
//                           display: 'flex',
//                           width: '100%',
//                           height: '36px',
//                           zIndex: 2,
//                           lineHeight: 1,
//                           fontSize: '13px',
//                           fontWeight: 600,
//                         }}
//                       >
//                         <Box
//                           sx={{
//                             backgroundColor: '#f7931e',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             whiteSpace: 'nowrap',
//                             clipPath: 'polygon(0 0, 100% 0, 75% 100%, 0% 100%)',
//                             padding: '3px 50px 6px 16px',
//                             marginRight: '-30px',
//                             height: '100%',
//                           }}
//                         >
//                           {isResidential ? 'Residential' : 'Commercial'}
//                         </Box>
//                         <Box
//                           sx={{
//                             backgroundColor: isReadyToMove ? '#00a885' : '#004b8d',
//                             color: '#fff',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             whiteSpace: 'nowrap',
//                             clipPath: 'polygon(15% 0, 100% 0, 100% 100%, 0 100%)',
//                             padding: isReadyToMove ? '3px 46px 6px 80px' : '6px 46px 6px 60px',
//                             height: '100%',
//                           }}
//                         >
//                           {isReadyToMove ? 'Ready to Move' : 'Under Construction'}
//                         </Box>
//                       </Box>
//                     </Box>

//                     <CardContent
//                       sx={{
//                         padding: '15px',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         gap: '10px',
//                         flexGrow: 1,
//                         width: '90% !important',
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'flex-start',
//                           gap: '10px',
//                           minHeight: '50px',
//                         }}
//                       >
//                         <Typography
//                           sx={{
//                             fontSize: '18px',
//                             fontWeight: 600,
//                             color: '#000',
//                             overflow: 'hidden',
//                             textOverflow: 'ellipsis',
//                             display: '-webkit-box',
//                             WebkitLineClamp: 2,
//                             WebkitBoxOrient: 'vertical',
//                             flex: 1,
//                           }}
//                         >
//                           {property.property_name}
//                         </Typography>

//                         {/* ✅ FIXED: Price display with proper logic */}
//                         <Typography
//                           sx={{
//                             fontSize: '14px',
//                             color: '#2563EB',
//                             fontWeight: 300,
//                             whiteSpace: 'nowrap',
//                             alignSelf: 'flex-start',
//                           }}
//                         >
//                           {displayPrice ? (
//                             <>
//                               ₹ {formatPrice(displayPrice)}
//                               {isRental && '/month'}
//                             </>
//                           ) : (
//                             'Price on Request'
//                           )}
//                         </Typography>
//                       </Box>

//                       <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#666', gap: '6px', minHeight: '24px' }}>
//                         <LocationOnIcon fontSize="small" sx={{ color: '#666' }} />
//                         <Typography
//                           sx={{
//                             overflow: 'hidden',
//                             textOverflow: 'ellipsis',
//                             whiteSpace: 'nowrap',
//                           }}
//                         >
//                           {property.location}, {property.area_name}
//                         </Typography>
//                       </Box>

//                       {/* ✅ UPDATED: Only render amenities if there are valid ones */}
//                       {propertyAmenities.length > 0 && (
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'center',
//                             width: '100%',
//                             minHeight: '70px',
//                             gap: '8px',
//                           }}
//                         >
//                           {propertyAmenities.map((amenity, idx) => (
//                             <Box
//                               key={idx}
//                               sx={{
//                                 flex: 1,
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 gap: '6px',
//                               }}
//                             >
//                               <Box sx={{ color: '#666', fontSize: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                                 {amenity.icon}
//                               </Box>
//                               <Typography
//                                 sx={{
//                                   fontSize: '13px',
//                                   color: '#444',
//                                   textAlign: 'center',
//                                   lineHeight: 1.2,
//                                 }}
//                               >
//                                 {amenity.value}
//                               </Typography>
//                             </Box>
//                           ))}
//                         </Box>
//                       )}

//                       <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 'auto', pt: '10px' }}>
//                         <Button
//                           component={Link}
//                           to={`/view/${property.id}`}
//                           variant="contained"
//                           onClick={() => handleViewProperty(property.id)}
//                           sx={{
//                             padding: '10px 44px',
//                             backgroundColor: '#005eff',
//                             color: 'white',
//                             borderRadius: '10px',
//                             cursor: 'pointer',
//                             fontWeight: 500,
//                             width: { xs: '100%', sm: 'fit-content' },
//                             '&:hover': {
//                               backgroundColor: '#004ecb',
//                             },
//                           }}
//                         >
//                           View Property
//                         </Button>
//                       </Box>
//                     </CardContent>
//                   </Card>
//                 </Box>
//               );
//             })}
//           </Box>

//           {/* ✅ Pagination component - Right aligned */}
//           {totalPages > 1 && (
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
//               <Pagination
//                                 count={totalPages}
//                 page={page}
//                 onChange={handlePageChange}
//                 color="primary"
//                 size={isMobile ? "small" : "medium"}
//                 showFirstButton
//                 showLastButton
//                 sx={{
//                   '& .MuiPaginationItem-root': {
//                     color: '#333',
//                   },
//                   '& .Mui-selected': {
//                     backgroundColor: '#005eff !important',
//                     color: 'white',
//                   }
//                 }}
//               />
//             </Box>
//           )}
//         </>
//       ) : null}
//     </Box>
//   );
// };

// export default FeaturedView;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  useMediaQuery,
  Pagination
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addProperty } from '../../../Commonlibs/userSlice';
import Loader from '../../../Loader/Loader';

import BedIcon from '@mui/icons-material/Bed';
import ApartmentIcon from '@mui/icons-material/Apartment';
import SquareFootIcon from '@mui/icons-material/SquareFoot';

const FeaturedView = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isLoggedIn = useSelector(state => state.user.isAuthenticated);
  const userData = useSelector(state => state.user.user);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalProperties, setTotalProperties] = useState(0);

  // Function to get user-friendly error message
  const getUserFriendlyErrorMessage = (error) => {
    const errorString = error.toString().toLowerCase();
    
    if (errorString.includes('fetch') || 
        errorString.includes('network') || 
        errorString.includes('failed to fetch') ||
        errorString.includes('networkerror') ||
        errorString.includes('connection')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('timeout')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('500') || errorString.includes('server error')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('404') || errorString.includes('not found')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    return 'Unable to load the properties. Please check your internet connection and try again.';
  };

  useEffect(() => {
    const fetchCommercialProperties = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          `https://propertydealstalk.com/api/property/getPropertiesByType?property_type=commercial&page=${page}&limit=10`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.success && data.properties) {
          setProperties(data.properties);

          if (data.pagination) {
            setTotalPages(data.pagination.totalPages);
            setTotalProperties(data.pagination.total);
          }

          data.properties.forEach(property => {
            dispatch(addProperty(property.id));
          });
        } else {
          throw new Error('Unable to load properties');
        }
      } catch (err) {
        console.error('Error fetching commercial properties:', err);
        const friendlyMessage = getUserFriendlyErrorMessage(err);
        setError(friendlyMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchCommercialProperties();
  }, [dispatch, page]);

  const recordPropertyView = async (propertyId) => {
    if (!isLoggedIn || !userData) {
      console.log('User not logged in, skipping view recording');
      return;
    }

    try {
      const userId = userData.id;

      if (!userId) {
        console.error('User ID not found in user data');
        return;
      }

      console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

      const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          property_id: propertyId
        }),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        console.log('Property view recorded successfully:', data.result);
      } else {
        console.error('Failed to record property view:', data.message);
      }
    } catch (err) {
      console.error('Error recording property view:', err);
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const formatPrice = (price) => {
    if (!price || price === 0 || price === '0') return '';
    
    const priceStr = price.toString();
    const lastThree = priceStr.substring(priceStr.length - 3);
    const otherNumbers = priceStr.substring(0, priceStr.length - 3);
    
    if (otherNumbers !== '') {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    }
    
    return lastThree;
  };

  const hasValidImage = (base64) => {
    return base64 && base64.length > 100 && base64 !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEEoSeleaKApYsGNby651rbv2Xda1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=";
  };

  const isValidValue = (value) => {
    return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
  };

  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const intervals = {
      y: 31536000,
      mo: 2592000,
      w: 604800,
      d: 86400,
      h: 3600,
      m: 60,
      s: 1
    };
    
    for (const [key, value] of Object.entries(intervals)) {
      const interval = Math.floor(diffInSeconds / value);
      if (interval >= 1) {
        return `${interval}${key} ago`;
      }
    }
    
    return 'just now';
  };

  const getDisplayPrice = (property) => {
    const category = property.category || property.commercial_catgory || '';
    const isRental = category.toLowerCase() === 'rent';

    if (isRental) {
      if (isValidValue(property.monthly_rent) && property.monthly_rent !== 0) {
        return property.monthly_rent;
      }
    }

    if (isValidValue(property.asking_price) && property.asking_price !== 0) {
      return property.asking_price;
    }

    return null;
  };

  const getPropertyAmenities = (property) => {
    const amenities = [];

    if (isValidValue(property.bhk)) {
      amenities.push({
        type: 'BHK',
        value: `${property.bhk} BHK`,
        icon: <BedIcon />
      });
    }

    if (isValidValue(property.select_floor) && isValidValue(property.total_floors)) {
      amenities.push({
        type: 'Floor',
        value: `${property.select_floor}/${property.total_floors} Floor`,
        icon: <ApartmentIcon />
      });
    }

    if (isValidValue(property.property_size)) {
      const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
      amenities.push({
        type: 'Size',
        value: `${property.property_size} ${sizeUnit}`,
        icon: <SquareFootIcon />
      });
    }

    return amenities;
  };

    const handleViewProperty = (propertyId) => {
    recordPropertyView(propertyId);
    dispatch(addProperty(propertyId));
  };

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        padding: '0 20px 40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
        marginTop: '30px',
        fontFamily: 'Outfit',
      }}
    >
      {loading && <Loader />}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '20px 0',
          position: 'relative',
        }}
      >
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          <Typography
            sx={{
              fontSize: '1.5rem',
              fontWeight: 600,
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 'auto',
            }}
          >
            Commercial Properties
          </Typography>
        </Box>
        <Button
          component={Link}
          to="/"
          variant="text"
          sx={{
            color: '#626262',
            fontSize: '0.8rem',
            fontWeight: 500,
            zIndex: 1,
            marginLeft: 'auto',
          }}
        >
          Back to Home
        </Button>
      </Box>

      {error ? (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            p: 4,
            textAlign: 'center',
            minHeight: '300px'
          }}
        >
          <Typography 
            sx={{ 
              color: '#666',
              fontSize: '1.1rem',
              fontWeight: 500,
              maxWidth: '600px'
            }}
          >
            {error}
          </Typography>
        </Box>
      ) : properties.length === 0 && !loading ? (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            p: 4,
            textAlign: 'center',
            minHeight: '300px'
          }}
        >
          <Typography 
            sx={{ 
              color: '#666',
              fontSize: '1.1rem',
              fontWeight: 500
            }}
          >
            No commercial properties found
          </Typography>
        </Box>
      ) : !loading ? (
        <>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
                md: 'repeat(3, 1fr)',
                lg: 'repeat(4, 1fr)',
              },
              gap: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
              justifyItems: 'center',
              alignItems: 'stretch',
            }}
          >
            {properties.map((property) => {
              const isResidential = property.property_type === 'residential';
              const isReadyToMove = property.construction_status === 'ready to move';
              const hasImage = hasValidImage(property.image);
              const propertyAmenities = getPropertyAmenities(property);
              const displayPrice = getDisplayPrice(property);
              const isRental = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';
              const timeAgo = getTimeAgo(property.updatedAt || property.createdAt);

              return (
                <Card
                  key={property.id}
                  sx={{
                    width: '100%',
                    maxWidth: { xs: '100%', sm: 350, md: 350, lg: 350 },
                    height: '100%',
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                    },
                  }}
                >
                  <Box sx={{ position: 'relative', width: '100%', height: 200, overflow: 'hidden' }}>
                    {hasImage ? (
                      <CardMedia
                        component="img"
                        image={`data:image/png;base64,${property.image}`}
                        alt={property.property_name}
                        sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          border: '1px dashed #ccc'
                        }}
                      >
                        <Typography variant="body2" color="#888" textAlign="center" px={2}>
                          No images uploaded
                        </Typography>
                      </Box>
                    )}

                    {timeAgo && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '8px',
                          right: '8px',
                          bgcolor: 'rgba(0, 0, 0, 0.7)',
                          color: '#fff',
                          px: '8px',
                          py: '4px',
                          borderRadius: '4px',
                          fontSize: '11px',
                          fontWeight: 500,
                          zIndex: 3,
                        }}
                      >
                        {timeAgo}
                      </Box>
                    )}

                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        display: 'flex',
                        width: '100%',
                        height: '36px',
                        zIndex: 2,
                        lineHeight: 1,
                        fontSize: '13px',
                        fontWeight: 600,
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: '#f7931e',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          whiteSpace: 'nowrap',
                          clipPath: 'polygon(0 0, 100% 0, 75% 100%, 0% 100%)',
                          padding: '3px 50px 6px 16px',
                          marginRight: '-30px',
                          height: '100%',
                        }}
                      >
                        {isResidential ? 'Residential' : 'Commercial'}
                      </Box>
                      <Box
                        sx={{
                          backgroundColor: isReadyToMove ? '#00a885' : '#004b8d',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          whiteSpace: 'nowrap',
                          clipPath: 'polygon(15% 0, 100% 0, 100% 100%, 0 100%)',
                          padding: isReadyToMove ? '3px 46px 6px 80px' : '6px 46px 6px 60px',
                          height: '100%',
                        }}
                      >
                        {isReadyToMove ? 'Ready to Move' : 'Under Construction'}
                      </Box>
                    </Box>
                  </Box>

                  <CardContent
                    sx={{
                      padding: '15px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                      flexGrow: 1,
                      width: '90% !important',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        gap: '10px',
                        minHeight: '50px',
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: '18px',
                          fontWeight: 600,
                          color: '#000',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          flex: 1,
                        }}
                      >
                        {property.property_name}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: '14px',
                          color: '#2563EB',
                          fontWeight: 300,
                          whiteSpace: 'nowrap',
                          alignSelf: 'flex-start',
                        }}
                      >
                        {displayPrice ? (
                          <>
                            ₹ {formatPrice(displayPrice)}
                            {isRental && '/month'}
                          </>
                        ) : (
                          'Price on Request'
                        )}
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#666', gap: '6px', minHeight: '24px' }}>
                      <LocationOnIcon fontSize="small" sx={{ color: '#666' }} />
                      <Typography
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {property.location}, {property.area_name}
                      </Typography>
                    </Box>

                    {propertyAmenities.length > 0 && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                          minHeight: '70px',
                          gap: '8px',
                        }}
                      >
                        {propertyAmenities.map((amenity, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              flex: 1,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                            }}
                          >
                            <Box sx={{ color: '#666', fontSize: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {amenity.icon}
                            </Box>
                            <Typography
                              sx={{
                                fontSize: '13px',
                                color: '#444',
                                textAlign: 'center',
                                lineHeight: 1.2,
                              }}
                            >
                              {amenity.value}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    )}

                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 'auto', pt: '10px' }}>
                      <Button
                        component={Link}
                        to={`/view/${property.id}`}
                        variant="contained"
                        onClick={() => handleViewProperty(property.id)}
                        sx={{
                          padding: '10px 44px',
                          backgroundColor: '#005eff',
                          color: 'white',
                          borderRadius: '10px',
                          cursor: 'pointer',
                          fontWeight: 500,
                          width: { xs: '100%', sm: 'fit-content' },
                          '&:hover': {
                            backgroundColor: '#004ecb',
                          },
                        }}
                      >
                        View Property
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              );
            })}
          </Box>

          {totalPages > 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                size={isMobile ? "small" : "medium"}
                showFirstButton
                showLastButton
                sx={{
                  '& .MuiPaginationItem-root': {
                    color: '#333',
                  },
                  '& .Mui-selected': {
                    backgroundColor: '#005eff !important',
                    color: 'white',
                  }
                }}
              />
            </Box>
          )}
        </>
      ) : null}
    </Box>
  );
};

export default FeaturedView;
